<template>
    <div>
        <v-row>
            <v-col cols="12">
                <v-card outlined>
                    <v-card-title class="text-subtitle-1 white--text" style="background-color: #1565c0;" dark>
                        Pendientes
                    </v-card-title>
                    <v-card-text class="px-1 mt-5">
                        <v-expansion-panels accordion>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Actividades pendientes</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense>
                                        <template v-if="actividadesAlumnoFilter.length < 1">
                                            <v-col cols="12">
                                                <v-card outlined>
                                                    <v-card-text style="height: 80px;"
                                                        class="d-flex justify-center align-center">
                                                        Sin actividades pendientes
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                        <template v-else>
                                            <v-col cols="12" v-for="item in actividadesAlumnoFilter" :key="item.id">
                                                <v-card color="light-gray">
                                                    <v-card-text>
                                                        <v-row dense>
                                                            <v-col cols="8">
                                                                <v-row dense>
                                                                    <v-col cols="12"
                                                                        class="font-weight-black primary--text">
                                                                        <v-icon icon left x-small>fas fa-list</v-icon>
                                                                        {{ item.desc_tipo_actividad }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="d-flex caption">
                                                                        {{ item.desc_curso }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="d-flex gap-10px">
                                                                        <v-chip label x-small>
                                                                            Vence : {{ item.fecha_actividad |
                                                                                filtroFecha }}
                                                                        </v-chip>
                                                                        <v-chip label x-small>
                                                                            {{ item.hora_fin_actividad |
                                                                                filtroFormatoHora
                                                                            }}
                                                                        </v-chip>
                                                                    </v-col>
                                                                </v-row>

                                                            </v-col>
                                                            <v-col cols="4" class="d-flex justify-center align-center">
                                                                <v-chip x-small>
                                                                    <v-icon left x-small>
                                                                        fas fa-info
                                                                    </v-icon>
                                                                    {{ item.actividad_vencidad == true ? 'No realizada'
                                                                        :
                                                                        item.desc_estado_alumno }}
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Evaluaciones pendientes</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense>
                                        <template v-if="dataEvaluacion.length < 1">
                                            <v-col cols="12">
                                                <v-card outlined>
                                                    <v-card-text style="height: 80px;"
                                                        class="d-flex justify-center align-center">
                                                        Sin evaluaciones pendientes
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                        <template v-else>
                                            <v-col cols="12" v-for="item in dataEvaluacion" :key="item.id">
                                                <v-card color="light-gray">
                                                    <v-card-text>
                                                        <v-row dense>
                                                            <v-col cols="8">
                                                                <v-row dense>
                                                                    <v-col cols="12"
                                                                        class="font-weight-black primary--text">
                                                                        <v-icon icon left x-small>fas fa-list</v-icon>
                                                                        {{ item.desc_tipo }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="d-flex caption">
                                                                        {{ item.desc_curso }}
                                                                    </v-col>
                                                                    <v-col cols="12">
                                                                        <v-chip label x-small>
                                                                            Dia : {{ item.fecha | filtroFecha }}
                                                                        </v-chip>

                                                                    </v-col>
                                                                    <v-col cols="12" class="d-flex gap-10px">
                                                                        <v-chip label x-small>
                                                                            {{ item.hora_inicio | filtroFormatoHora }}
                                                                        </v-chip>
                                                                        <v-chip label x-small>
                                                                            {{ item.hora_fin | filtroFormatoHora }}
                                                                        </v-chip>
                                                                    </v-col>

                                                                </v-row>

                                                            </v-col>
                                                            <v-col cols="4" class="d-flex justify-center align-center">
                                                                <v-chip x-small>
                                                                    <v-icon left x-small>
                                                                        fas fa-info
                                                                    </v-icon>
                                                                    {{ item.estado_evaluacion }}
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            <v-expansion-panel>
                                <v-expansion-panel-header>Somos hábiles pendientes</v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row dense>
                                        <template v-if="filtroProgAlum.length < 1">
                                            <v-col cols="12">
                                                <v-card outlined>
                                                    <v-card-text style="height: 80px;"
                                                        class="d-flex justify-center align-center">
                                                        Sin somos hábiles pendientes
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                        <template v-else>
                                            <v-col cols="12" v-for="item in filtroProgAlum" :key="item.id">
                                                <v-card color="light-gray">
                                                    <v-card-text>
                                                        <v-row dense>
                                                            <v-col cols="8">
                                                                <v-row dense>
                                                                    <v-col cols="12"
                                                                        class="font-weight-black primary--text">
                                                                        <v-icon icon left x-small>fas fa-list</v-icon>
                                                                        {{ item.desc_curso }}
                                                                    </v-col>
                                                                    <v-col cols="12" class="d-flex caption">
                                                                        {{ item.nombre_clase }}
                                                                    </v-col>
                                                                    <v-col cols="12">
                                                                        <v-chip label x-small>
                                                                            Dia : {{ item.fecha_creacion_examen |
                                                                                filtroFecha }}
                                                                        </v-chip>

                                                                    </v-col>
                                                                </v-row>

                                                            </v-col>
                                                            <v-col cols="4" class="d-flex justify-center align-center">
                                                                <v-chip x-small>
                                                                    <v-icon left x-small>
                                                                        fas fa-info
                                                                    </v-icon>
                                                                    {{ item.estado_examen == true ?
                                                                        'Pendiente' : 'Por habilitar' }}
                                                                </v-chip>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card-text>
                                                </v-card>
                                            </v-col>
                                        </template>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import axios from "@/helpers/axios"
import { mapMutations, mapGetters, mapActions } from 'vuex';
export default {


    data: () => ({
        actividadesAlumnoFilter: [],
        datoLogin: sessionStorage,
        dataEvaluacion: [],
        filtroProgAlum: [],
        filter: {},



    }),
    mounted() {
        this.loadMain()
    },
    computed: {
        ...mapGetters('login', ['componenteEvento']),
    },

    methods: {
        ...mapMutations('mensajeSis', ['setEnviarMens']),
        ...mapActions('login', ['parametroComponente']),

        async loadMain() {
            this.limpiarForm();
            await this.getUserAlumno(this.datoLogin.id);
            this.getEvaluacionAlumno(this.filter);
            this.getSomoshabiles();
            this.getActividades();
        },

        async getEvaluacionAlumno(filter) {

            try {
                let response = await axios.post(`/evaluacion/alumnos/view/`, { filter })
                this.dataEvaluacion = response.data

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },

        async getUserAlumno(id_usuario) {

            let params = { id_usuario, id_ano_lectivo: this.datoLogin.id_ano_lectivo }

            try {
                let response = await axios.post(`/sistema/integral/getAlumnoAnoLectivo/`, { filter: params })
                let resp = response.data

                if (resp.length == 0) {
                    this.setEnviarMens({ tipo: "W", mensaje: `El usuario no es un estudiante`, tiempo: null })

                } else {
                    this.listAlumno = resp
                    this.filter.id_alumno = resp.id_alumno
                    this.filter.id_nivel = resp.id_nivel
                    this.filter.id_grado = resp.id_grado
                    this.filter.id_seccion = resp.id_seccion
                }

            } catch (error) {
                console.log(error)
                this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null })
            }

        },

        async getActividades() {
            try {
                let params = `periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/alumno/${this.datoLogin.id}`
                let response = await axios.get(`academico/actividades/alumnoActividad/${params}`)

                let data = response.data
                let filtrado = data.ActividadesAlumno.filter(item => item.desc_estado_alumno === 'Pendiente por realizar')
                this.actividadesAlumnoFilter = filtrado;
            }

            catch (error) {
                this.setEnviarMens({ tipo: "E", mensaje: `Error: ${error}`, tiempo: null })
            }
        },


        async getSomoshabiles() {
            try {
                let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/usuario/${this.datoLogin.id}`;
                let response = await axios.get(
                    `/academico/alumnoClase/getQuery${params}`,
                    {
                        params: {
                            search: this.search,
                        },
                    }
                );
                const { data } = response;

                if(data.length > 0) {
                    
                    this.filtroProgAlum = [];
                    let filterprog = data.payload.AlumnoClase.filter(item => item.estado_examen == true)
                    this.filtroProgAlum = filterprog
                }


            } catch (error) {
                this.setEnviarMens({
                    tipo: "E",
                    mensaje: `Error: ${error}`,
                    tiempo: null,
                });
            }
        },


        limpiarForm() {
            this.filter = {
                id_colegio: this.datoLogin.id_colegio,
                id_ano_lectivo: this.datoLogin.id_ano_lectivo,
                id_alumno: '',
                id_area: '',
                id_curso: '',
                id_seccion: ''
            }
        },
    }
}
</script>